
import {Component, Vue, Prop} from 'vue-property-decorator';
import Empty from '@/components/Empty/index.vue';
import * as echarts from 'echarts';
import {statisticsApi} from '@/api';
import moment from 'moment';
import EchartsTooltip from './EchartsTooltip.vue';
const chartTooltip = Vue.extend(EchartsTooltip);
@Component({
    components: {
        Empty
    }
})
export default class WorkData extends Vue {
    comparedChart = {};
    comparedChartOption = {};
    workRateData: any = [];
    initComparedWork() {
        const chartDom: HTMLElement | null = document.querySelector('#chartCompared');
        if (chartDom) {
            this.comparedChart = echarts.init(chartDom, undefined, {renderer: 'svg'});
            (this.comparedChart as echarts.ECharts).clear();
            this.comparedChartOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    borderColor: '#EBEDF0',
                    padding: 16,
                    enterable: true,
                    formatter: (params: any) => {
                        const index = params.findIndex((x: any) => x.seriesName);
                        if (this.hasData > -1 && index > -1) {
                            const com = new chartTooltip() as EchartsTooltip;
                            com.setData({params, dateType: this.formatDateType, tooltipsType: 'workData'});
                            com.$mount();
                            return com.$el.innerHTML;
                        } else {
                            return '';
                        }
                    }
                },
                color: ['#1456ED', '#2D85FF', '#17C980', '#FFCB22', '#FF7E1A', '#E53933', '#D73AB2', '#7831D4', '#5D7092'],
                legend: {
                    show: true,
                    bottom: 14,
                    icon: 'circle',
                    align: 'auto',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 32,
                    type: 'scroll',
                    textStyle: {
                        rich: {
                            a: {
                                verticalAlign: 'middle'
                            }
                        },
                        padding: [0, 0, 2, 0]
                    },
                    itemStyle: {
                        opacity: 1
                    }
                },
                grid: {
                    left: 8,
                    bottom: 48,
                    right: 24,
                    top: 16,
                    containLabel: true
                },
                xAxis: this.xAixsLength,
                yAxis: [
                    {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#EBEDF0'
                            }
                        },
                        axisLabel: {
                            color: 'rgba(0,0,0,0.6)'
                        },
                        splitNumber: 5,
                        max: () => {
                            if (this.autoMax) {
                                return 10;
                            } else {
                                return null;
                            }
                        }
                    }
                ],
                series: this.workRateData
            };
            this.$nextTick(() => {
                (this.comparedChart as echarts.ECharts).resize();
            });

            (this.comparedChart as echarts.ECharts).setOption(this.comparedChartOption);
            window.addEventListener('resize', () => {
                (this.comparedChart as echarts.ECharts).resize();
            });
        }
    }

    chartPie: any;
    charts: any = '';
    isEmpty = false;
    compareEmpty = false;
    opinionData: any = [];
    colorList = ['#1456ED', '#2D85FF', '#17C980', '#FFCB22', '#FF7E1A', '#E53933', '#D73AB2', '#7831D4', '#5D7092'];
    pieColorList: any = {1: '#EF8539', 2: '#2955E4', 4: '#D3483D', 5: '#4783F7', 6: '#F7CD4D', 98: '#5EC686', other: '#616F8F'};

    fromDate = '';
    formatDateType = 'day';
    XAixs: {}[] = [];
    onChange(val?: any) {
        if (val.target.value === 'year') {
            this.XAixs = this.getMonths(12);
        } else if (val.target.value === 'month') {
            this.XAixs = this.getDays(30);
        } else if (val.target.value === 'halfYear') {
            this.XAixs = this.getMonths(6);
        } else {
            this.XAixs = this.getDays(7);
        }
        this.getOptionsData();
        this.getWorkRateData();
    }
    getDays(day: number) {
        const dates = [];
        const NUM_OF_DAYS = day;

        this.formatDateType = 'day';
        this.fromDate = moment()
            .subtract(day - 1, 'day')
            .format('YYYY-MM-DD 00:00:00');
        for (let i = 0; i < NUM_OF_DAYS; i++) {
            const date = moment().subtract(i, 'day').format('YYYY-MM-DD');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    getMonths(month: number) {
        const dates = [];
        const NUM_OF_MONTHS = month;

        this.formatDateType = 'month';
        this.fromDate = moment()
            .subtract(month - 1, 'month')
            .format('YYYY-MM-DD 00:00:00');

        for (let i = 0; i < NUM_OF_MONTHS; i++) {
            const date = moment().subtract(i, 'month').format('YYYY-MM');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    // 作品提交情况
    total = 0;
    getOptionsData() {
        const urlQueryParmas = {
            startTime: this.fromDate,
            endTime: moment().format('YYYY-MM-DD 24:00:00')
        };
        statisticsApi.getExperimentWork({
            context: this,
            urlQueryParmas,
            success: async (data: any) => {
                if (data.code === 0) {
                    const codes: any = await this.getCodes();
                    const result = data.data.results
                        .filter((x: {type: string}) => x.type === '2' || x.type === '5' || x.type === '1')
                        .map((item: {type: any; count: any}, index: number) => {
                            this.total += item.count;
                            const codeItemName =
                                item.type === 'other' ? '其他' : codes.find((x: {value: any}) => x.value === item.type).name;
                            return {
                                value: item.count,
                                label: codeItemName,
                                name: item.count,
                                itemStyle: {color: this.pieColorList[item.type]},
                                key: item.type
                            };
                        });
                    this.opinionData = this.customSort({data: result, sortBy: this.sortBy, sortField: 'key'});
                    this.$nextTick(() => {
                        this.drawPieChart();
                    });
                }
            }
        });
    }
    // 排序
    sortBy = ['2', '1', '6', '5', '4', '98', '99', '100'];
    customSort({data, sortBy, sortField}: any) {
        const sortByObject = sortBy.reduce(
            (obj: any, item: any, index: any) => ({
                ...obj,
                [item]: index
            }),
            {}
        );
        return data.sort(
            (a: {[x: string]: string | number}, b: {[x: string]: string | number}) =>
                sortByObject[a[sortField]] - sortByObject[b[sortField]]
        );
    }
    getCodes() {
        return new Promise(resolve => {
            statisticsApi.getCodes({
                context: this,
                success: (data: any) => {
                    if (data.code === 0) {
                        const testPlatformCodeByValue = data.data['test_platform'];
                        resolve(testPlatformCodeByValue);
                    }
                }
            });
        });
    }
    drawPieChart() {
        const chartDom: HTMLElement | null = document.getElementById('chartPie');
        if (chartDom) {
            this.chartPie = echarts.init(chartDom, undefined, {renderer: 'svg'});
            this.chartPie.setOption({
                legend: {
                    show: false
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function (params: {data: {label: any; value: any}; percent: any}) {
                        return `${params.data.label}</br>${params.data.value}(${params.percent}%)`;
                    }
                },
                series: [
                    {
                        name: '实验类型',
                        type: 'pie',
                        radius: ['50%', '71%'],
                        data: this.opinionData,
                        animationEasing: 'cubicInOut',
                        animationDuration: 2600,
                        label: {
                            normal: {
                                show: true,
                                position: 'center',
                                color: '#4c4a4a',
                                formatter: '{total|' + this.total + '}' + '\n\r' + '{active|作品总数}',
                                rich: {
                                    total: {
                                        fontSize: 20,
                                        fontFamily: 'PingFangSC-Medium',
                                        color: 'rgba(0,0,0,0.9)'
                                    },
                                    active: {
                                        fontFamily: 'PingFangSC-Regular',
                                        fontSize: 14,
                                        color: 'rgba(0,0,0,0.6)',
                                        lineHeight: 30
                                    }
                                }
                            },
                            emphasis: {
                                //中间文字显示
                                show: true
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        }
                    }
                ]
            });
        }
    }

    hasData = -1;
    // 作品优秀率和批改率
    getWorkRateData() {
        const urlQueryParmas = {
            startTime: this.fromDate,
            endTime: moment().format('YYYY-MM-DD 24:00:00'),
            unit: this.formatDateType
        };
        statisticsApi.getWorkRate({
            context: this,
            urlQueryParmas,
            success: (data: any) => {
                if (data.code === 0) {
                    const tempData = data.data.result
                        .map((item: {correctInfos: any[]; countTime: any}) => {
                            if (item.correctInfos.length) {
                                item.correctInfos.forEach(child => {
                                    child.countTime = moment(item.countTime).format(
                                        this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'
                                    );
                                });
                            } else {
                                item.correctInfos[0] = {
                                    countTime: moment(item.countTime).format(this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'),
                                    correctWorkCount: 0,
                                    excellentWorkCount: 0,
                                    nickname: '',
                                    teacherId: ''
                                };
                            }

                            return item.correctInfos;
                        })
                        .flat();
                    if (!tempData.length) {
                        this.xAixsLength.push({
                            type: 'category',
                            axisTick: {
                                show: true,
                                alignWithLabel: true
                            },
                            axisLabel: {
                                show: true,
                                color: 'rgba(0,0,0,0.6)',
                                showMinLabel: true,
                                margin: 24,
                                formatter: (val: string) => {
                                    if (this.formatDateType === 'month') {
                                        return moment(val).format('YYYY.MM');
                                    } else {
                                        return moment(val).format('YYYY/MM/DD');
                                    }
                                }
                            }
                        });
                        this.workRateData = [
                            {
                                name: '',
                                type: 'bar',
                                xAxisIndex: 0,
                                itemStyle: {opacity: 0.5},
                                data: data.data.result.map((item: {countTime: any}) => {
                                    return [
                                        moment(item.countTime).format(this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'),
                                        0,
                                        {originData: {}}
                                    ];
                                })
                            }
                        ];
                    } else {
                        this.workRateData = this.formatData(tempData, 'teacherId');
                    }
                    this.hasData = this.workRateData.findIndex((x: {name: any}) => x.name);
                    this.$nextTick(() => {
                        this.initComparedWork();
                    });
                }
            }
        });
    }
    xAixsLength: any = [];
    autoMax = false;
    formatData(arr: any[], key: string) {
        const maxData = arr.map(item => {
            return item.correctWorkCount;
        });

        this.xAixsLength = [];
        let kind: any[] = []; //存放属性标识
        let newArr: any[][] = []; //返回的数据
        arr.forEach(item => {
            // 判断key是否存在，不存在则添加
            if (!kind.includes(item[key])) {
                kind.push(item[key]); //kind添加新标识
                newArr.push([]); //添加数组
            }
            let index = kind.indexOf(item[key]); //返回带有标识在kind内的下标，判断加入哪个数组
            newArr[index].push(item); //将对象存入数组
        });
        const temp = newArr.map(item => {
            return {name: item[0].nickname, type: 'bar', data: item};
        });
        const result = new Array();
        for (let i = 0; i < temp.length; i++) {
            result[i * 2] = {
                name: temp[i].name,
                type: 'bar',
                xAxisIndex: 0,
                // itemStyle: {normal: {color: this.opacityColorList[i]}},
                itemStyle: {opacity: 0.5},
                data: temp[i].data.map(item => {
                    return [item.countTime, item.correctWorkCount, {originData: item}];
                })
            };
            result[i * 2 + 1] = {
                name: temp[i].name,
                type: 'bar',
                xAxisIndex: 1,
                itemStyle: {normal: {color: this.colorList[i]}},
                data: temp[i].data.map(item => {
                    return [item.countTime, item.excellentWorkCount, {originData: item}];
                })
            };
        }
        for (let i = 0; i < result.length; i++) {
            if (i === 0) {
                this.xAixsLength.push({
                    type: 'category',
                    axisTick: {
                        show: true,
                        alignWithLabel: true
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgba(0,0,0,0.6)',
                        showMinLabel: true,
                        margin: 24,
                        formatter: (val: string) => {
                            if (this.formatDateType === 'month') {
                                return moment(val).format('YYYY.MM');
                            } else {
                                return moment(val).format('YYYY/MM/DD');
                            }
                        }
                    }
                });
            } else {
                this.xAixsLength.push({type: 'category', show: false});
            }
        }
        if (Math.max(...maxData) <= 10) {
            this.autoMax = true;
        } else {
            this.autoMax = false;
        }
        return result;
    }
    mounted() {
        this.$nextTick(() => {
            this.onChange({target: {value: 'month'}});
        });
    }
}
